import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/returning-party';
import { AdvancedSearchShipmentContext } from '../../context';
import messages from '../messages';

const ReturningParty = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.returningParty} updateFilter={updateFilter} />;
};

export default ReturningParty;
